import { useEffect } from "react";
import { useRobot } from "@/context/RobotContext";
import { Terminal, Trash, WifiHigh, Cube, Eye, Warning } from "@phosphor-icons/react";

const kindIcon = {
  command: Terminal,
  connection: WifiHigh,
  system: Cube,
  vision: Eye,
};

const statusColor = {
  success: "#00E676",
  error: "#FF3B30",
  warning: "#FFB000",
  info: "#94A3B8",
};

export default function ActivityLog() {
  const { logs, loadLogs, clearLogs } = useRobot();

  useEffect(() => {
    loadLogs();
  }, [loadLogs]);

  return (
    <div className="border border-[#272A35] bg-[#111318] h-full flex flex-col" data-testid="activity-log-container">
      <div className="border-b border-[#272A35] px-4 py-3 flex items-center justify-between">
        <span className="text-[10px] tracking-[0.2em] uppercase font-bold text-[#94A3B8] flex items-center gap-2">
          <Terminal size={16} weight="bold" className="text-[#FF5A00]" /> Activity Log
        </span>
        <button
          data-testid="clear-log-btn"
          onClick={clearLogs}
          className="text-[#475569] hover:text-[#FF3B30] transition-colors"
          title="Clear log"
        >
          <Trash size={15} weight="bold" />
        </button>
      </div>

      <div className="flex-1 overflow-y-auto bg-[#0A0B0E] p-3 font-mono text-xs space-y-1.5 min-h-[200px]">
        {logs.length === 0 ? (
          <p className="text-[#475569]">
            {"> "}awaiting telemetry<span className="cursor-blink">█</span>
          </p>
        ) : (
          logs.map((l) => {
            const Icon = kindIcon[l.kind] || Warning;
            const color = statusColor[l.status] || "#94A3B8";
            const time = new Date(l.timestamp).toLocaleTimeString();
            return (
              <div key={l.id} className="flex items-start gap-2 leading-relaxed">
                <span className="text-[#475569] shrink-0">{time}</span>
                <Icon size={13} weight="bold" style={{ color }} className="mt-0.5 shrink-0" />
                <span style={{ color }} className="break-all">{l.message}</span>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}
